import React from 'react'
import SideBar from '../Partials/SideBar'
import RelatedSection from '../Partials/RelatedSection'
import BlogPost from './BlogPost'

function NewsPost() {

    const NewsPost = true;


    return (
        <>
            <div className="mt-7 w-full max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                    <BlogPost NewsPost={NewsPost} />
                    <SideBar />
                </div>
            </div>
        </>
    )
}

export default NewsPost